import {AppState} from '../../appState';

/*
 * Selectors.
 */

export function getCellsLists(state: AppState) {
  return state.metadata.cellsLists;
}
